// extracted by mini-css-extract-plugin
module.exports = {"submitWrapper":"UpdatePasswordForm__submitWrapper___1TOmV AccountPage__submitWrapper___22KMu"};